import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { default as LinkComponent } from 'components/Link';
import { ArrowUp, ArrowDown } from 'components/icons';

const propertyCellHeight = '85px';

export const Title = styled('h1')(() => ({
  margin: 0
}));

export const Header = styled('div')(({ theme }) => ({
  padding: theme.spacing(5)
}));

export const Content = styled('div')(({ theme }) => ({
  background: theme.color.background.surface,
  marginBottom: theme.spacing(5)
}));

export const PropertyContainer = styled('div')(({ theme }) => ({
  background: theme.color.grey['200']
}));

export const PropertyContainerTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  padding: theme.spacing(5)
}));

export const PropertyContainerText = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(0)} ${theme.spacing(5)}`,
  fontSize: theme.spacing(2),
  lineHeight: theme.spacing(3)
}));

export const PropertyContainerRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  flexFlow: 'row wrap',
  backgroundImage: `linear-gradient(180deg, ${theme.color.grey['400']} 50%, ${theme.color.grey['200']} 50%)`,
  backgroundRepeat: 'repeat',
  backgroundSize: `100px calc(2 * (${propertyCellHeight} + ${theme.spacing(4)}))`
}));

export const PropertyContainerCell = styled('div')(({ theme }) => ({
  flex: '0 0 200px',
  height: propertyCellHeight,
  padding: `${theme.spacing(2)} ${theme.spacing(5)}`,
  label: {
    display: 'block',
    width: '100%',
    fontSize: theme.spacing(2),
    fontWeight: theme.fontWeight.bold,
    lineHeight: theme.spacing(3),
    color: theme.color.text.highlight,
    '&:first-child': {
      fontWeight: theme.fontWeight.normal
    }
  }
}));

export const AttachmentsContainer = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(5)} 0px`,
  padding: `${theme.spacing(5)} ${theme.spacing(5)}`,
  borderTop: '1px solid #ccc',
  display: 'flex',
  flexFlow: 'wrap',
  background: theme.color.grey['200'],
  header: {
    width: '100%',
    display: 'block'
  },
  a: {
    color: theme.color.text.main,
    textDecoration: 'none',
    display: 'flex',
    flexFlow: 'column',
    width: '130px',
    wordBreak: 'break-all',
    margin: `${theme.spacing(3)} ${theme.spacing(5)}`
  }
}));

export const InformationContainer = styled('div')(({ theme }) => ({
  background: theme.color.primary.contrast,
  position: 'relative',
  paddingBottom: theme.spacing(5)
}));

export const InformationContainerTitle = styled(Typography)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  fontWeight: theme.fontWeight.bold,
  padding: theme.spacing(5),
  label: {
    marginLeft: theme.spacing(2)
  }
}));

export const InformationContainerSubTitle = styled(Typography)(({ theme }) => ({
  padding: `${theme.spacing(0)} ${theme.spacing(5)}`,
  fontWeight: theme.fontWeight.bold,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  label: {
    marginLeft: theme.spacing(2)
  }
}));

export const ShowHideDetailsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignContent: 'center',
  padding: theme.spacing(2)
}));

export const Link = styled(LinkComponent)(({ theme, selected }) => ({
  alignItems: 'center',
  cursor: 'pointer',
  color: '#206AF5',
  display: 'inline-flex',
  ...(selected && {
    fontWeight: theme.fontWeight.bold
  }),
  height: '100%',
  lineHeight: '100%',
  position: 'relative',
  width: '200px',
  justifyContent: 'center'
}));

export const DownArrow = styled(ArrowDown)(() => ({
  width: '40px',
  height: '40px',
  color: 'black'
}));

export const UpArrow = styled(ArrowUp)(() => ({
  width: '40px',
  height: '40px',
  color: 'black'
}));
